import React from 'react';
import { useTranslation } from 'react-i18next';
import { DescriptionLabel, ParagraphList, SectionHeader } from 'web-library';
import { useUserDetails } from '../../../../hooks/userDetails';
import { Role } from '../../../../models';

const Instruction = () => {
  const { t } = useTranslation();
  const { data: userDetails } = useUserDetails();

  return (
    <>
      {userDetails && userDetails?.data.roles?.includes(Role.candidate) && (
        <>
          <SectionHeader title={t('resit->>ResitInstruction.Registration Instructions')} />

          <ParagraphList
            label={t('resit->>ResitInstruction.In this registration process, you will:')}
            ordered
            listData={[
              t(
                'resit->>ResitInstruction. (1) Select the subject(s) that you are eligible to register'
              ),
              t('resit->>ResitInstruction. (2) Verify your personal particulars are correct; and'),
              t(
                'resit->>ResitInstruction. (3) Confirm your registration details and submit payment'
              ),
            ]}
          />

          <DescriptionLabel
            label={t(
              'resit->>ResitInstruction.(Enable pop-ups in your web browser settings before you begin.)'
            )}
          />

          <DescriptionLabel
            label={t('resit->>ResitInstruction.Click "Start" to begin the registration.')}
          />
        </>
      )}
      {userDetails && userDetails?.data.roles?.includes(Role.coordinator) && (
        <>
          <SectionHeader
            title={t('resit->>ResitInstruction.Key Instructions for Resit Registration')}
          />

          <ParagraphList
            label={t('resit->>ResitInstruction.1. Please provide the following information')}
            ordered={false}
            listData={[
              t('resit->>ResitInstruction. • Candidate’s Personal Particulars'),
              t('resit->>ResitInstruction. • Subjects/Papers to be registered'),
            ]}
          />

          <DescriptionLabel
            label={t(
              'resit->>ResitInstruction.2. All fields are mandatory; the form must be completed in English.'
            )}
          />

          <DescriptionLabel
            label={t(
              'resit->>ResitInstruction.This application form may take you 5 minutes to complete.'
            )}
          />
        </>
      )}
    </>
  );
};

export default Instruction;
